import { useRef } from "react";
import QRCode from "react-qr-code"
import { useDispatch } from "react-redux";
import { setShowToast, setToast } from "_redux/slices/timeline/timeline-toast";

const CustomQrCode = ({ link, showInstructions, instructions, filename }) => {

    const qrRef = useRef(null);
    const dispatch = useDispatch();

    const handleCopyURL = () => {

        navigator.clipboard.writeText(link)
        dispatch(setToast({
            message: "Copy Link successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    }

    const handleDownloadQrCode = () => {
        const svg = qrRef.current?.querySelector("svg");
        if (!svg) return;

        const svgData = new XMLSerializer().serializeToString(svg);

        const viewBox = svg.viewBox.baseVal;
        const width = viewBox?.width || 256;
        const height = viewBox?.height || 256;

        // Optional: export bigger PNG without cropping
        const scale = 4;

        const canvas = document.createElement("canvas");
        const padding = 20;

        canvas.width = (width + padding * 2) * scale;
        canvas.height = (height + padding * 2) * scale;

        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
            ctx?.clearRect(0, 0, canvas.width, canvas.height);

            ctx?.drawImage(
                img,
                padding * scale,
                padding * scale,
                width * scale,
                height * scale
            );

            const pngUrl = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = pngUrl;
            link.download = `${filename}.png`;
            link.click();
        };

        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;

    };


    // const handleDownloadQrCode = () => {
    //     const svg = qrRef.current?.querySelector("svg");
    //     const canvas = qrRef.current?.querySelector("canvas");
    //     if (canvas) {
    //         // For canvas-based QR code (react-qrcode-logo default)
    //         const pngFile = canvas.toDataURL("image/png");
    //         const downloadLink = document.createElement("a");
    //         downloadLink.href = pngFile;
    //         downloadLink.download = `${filename}.png`;
    //         downloadLink.click();
    //     } else if (svg) {
    //         // For svg-based QR codes
    //         const svgData = new XMLSerializer().serializeToString(svg);
    //         const img = new Image();
    //         const canvasEl = document.createElement("canvas");
    //         const ctx = canvasEl.getContext("2d");

    //         img.onload = function () {
    //             canvasEl.width = img.width;
    //             canvasEl.height = img.height;
    //             ctx.drawImage(img, 0, 0);
    //             const pngFile = canvasEl.toDataURL("image/png");

    //             const downloadLink = document.createElement("a");
    //             downloadLink.href = pngFile;
    //             downloadLink.download = `${filename}.png`;
    //             downloadLink.click();
    //         };

    //         img.src = "data:image/svg+xml;base64," + btoa(svgData);
    //     } else {
    //         console.error("QR code not found.");
    //     }
    // };

    return (
        <div className="text-center mt-4">
            <div ref={qrRef} className='mt-3'>
                <QRCode
                    size={150}
                    value={link}
                    style={{ height: "350px", maxWidth: "350%", width: "75%", margin: "10px auto" }}

                />

            </div>
            {showInstructions && <p className="mt-2 text-muted" style={{ fontSize: "0.9rem" }}>
                {instructions}
            </p>}
            <button onClick={handleDownloadQrCode} className="mt-2 btn btn-success">
                Download QR Code
            </button>

            <button onClick={handleCopyURL} className="mt-2 btn">
                Copy Link
            </button>

        </div>
    )
}

export default CustomQrCode